module.exports = __webpack_public_path__ + "fe3e7487eb3489b15181306c566a1c0c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-basketball.png
// module id = 1332
// module chunks = 0